import template from './template.html';
import blockBase from "../../mixins/blockBase";
import {union} from 'lodash';

export default {
    name: 'cases',
    template: template,
    mixins: [
        blockBase,
    ],
    data() {
      return {
          list: null,
          cats: [{
              id: 0,
              name: 'All'
          }],
          activeRadio: 0 // 0 means all cases
      }
    },
    methods: {
        getCaseCategories(item) {
            return this.$store.getters.getCaseCategoriesByIds(item['case-categories']);
        },
        onFieldsLoaded() {
            if (this.fields) {
                this.$store.dispatch('fetchCasesByIds', this.fields.case_list_objects);
            }
        },
    },
    computed: {
        fields() {
            return this.$store.getters.getAcfOptionField('cases');
        },
        cases() {
            let vm = this;
            this.list = this.$store.getters.getCases();
            if (this.activeRadio === 0) { // return all
                return this.list;
            }
            this.list = this.list.filter(item => item['case-categories'].includes(vm.activeRadio));
            return this.list;
        },
        categories() {
            this.cats = union(this.cats, this.$store.getters.getCaseCategories());
            return this.cats;
        }
    },
    watch: {
        fields: 'onFieldsLoaded'
    },
    created() {
        this.onFieldsLoaded();
        this.$store.dispatch('fetchCaseCategories');
    }
};